import React, { Component } from 'react'
import { Route } from 'react-router-dom'
//import { Link } from 'react-router-dom'
import '../../styles/GlobalStyle.css'
//import CustomFooter from '../../login/CustomFooter'
//import SubjectHistogram from '../../admin/SubjectHistogram'
//import SupportPieChartTiers from '../../admin/SupportPieChartTiers'
//import PersonAvatar from '../../customcomponents/PersonAvatar'
//import Empty from '../../customcomponents/Empty'
//import { getIDFromURL } from '../.././Util'
import PacingGuideSC from './PacingGuideSC'
import PacingGuideLessonPlanV2 from './PacingGuideLessonPlanV2'
import PacingGuideLessonPlanV3 from './PacingGuideLessonPlanV3'
import WeeklyPlanner from './WeeklyPlanner'
import Games from './../../games/games'
import { db, firebase } from '../../firebase/Firebase'
import ColType from '../.././Types'
import { flattenDoc, getCurrentTimestamp, getPacingGuideWeekIndexDay, getWeekConnectionKeys, getSCBiology1Standards, getSchoolWeekNumber, getStandardsColType, getStateStandardCategories, getStateStandardNamesDict } from '../../Util'
import { Button } from 'antd'
//const { Content } = Layout

const PacingGuideComponent = (props, pacingGuideBaseProps, state) => {
    // other state pacing guides can be handled here with conditionals
    return <PacingGuideSC
        pacingGuideBaseProps={state}
        teacherBaseProps={pacingGuideBaseProps.teacherBaseProps}
        {...props}
    />
}

const LessonPlanComponent = (props, pacingGuideBaseProps, state) => {
    return <PacingGuideLessonPlanV3
        pacingGuideBaseProps={state}
        teacherBaseProps={pacingGuideBaseProps.teacherBaseProps}
        {...props}
    />
}

const WeeklyPlannerComponent = (props, pacingGuideBaseProps, state) => {
    return <WeeklyPlanner
        pacingGuideBaseProps={state}
        teacherBaseProps={pacingGuideBaseProps.teacherBaseProps}
        {...props}
    />
}

const GamesComponent = (props, pacingGuideBaseProps, state) => {
    if (!(state && state.pacingGuide &&
        state.activeYear && state.standardYears
    )) {
        return <div></div>;
    }
    return <Games
        pacingGuideBaseProps={state}
        teacherBaseProps={pacingGuideBaseProps.teacherBaseProps}
        {...props}
    />
}

class PacingGuide extends Component {
    state = {
        prevStandardName: '',
        prevStandardCategory: '',
        standardName: 'Kindergarten',
        standardCategory: 'ELA',
        standardCategories: ['ELA', 'Math', 'Social Studies', 'Science'],
        standards: [],
        standardsDict: {},
        standardNamesDict: {},
        // {contentKey: connection doc}; empty until loaded, and stays empty if
        // the read fails or the district has none.
        weekConnectionsDict: {},
        // {weekNumber: contentKey} derived from this district's own guide
        weekConnectionKeys: {},
        // standards that will be official in the future
        futureStandards: [],
        futureStandardsDict: {},
        setWeeksFunc: (weeks) => { },
        onStandardNameChangeFunc: (value) => { },
        onStandardCategoryChangeFunc: (value) => { },
        setStandardNameAndCategoryFunc: (standardName, standardCategory) => { },
        onSetActiveYearFunc: (year) => { },
        onSetPacingGuideMode: (mode) => { },
        setActiveSchoolFunc: (schoolId) => { },
        totalWeeks: 37,
        weeks: null,
        weekNums: [],
        gradeDictAcrossCategories: {
            'Kindergarten': 'K',
            '1st Grade': '1',
            '2nd Grade': '2',
            '3rd Grade': '3',
            '4th Grade': '4',
            '5th Grade': '5',
            '6th Grade': '6',
            '7th Grade': '7',
            '8th Grade': '8',
        },
        pacingGuide: null,
        pacingGuideListener: null,
        futurePacingGuide: null,
        pacingGuideStats: null,
        activeSchoolId: '',
        scheduledStandardsDict: {},
        mounted: false,
        pacingGuidePDFURL: '',
        pacingGuidePDFURLLoading: false,
        pacingGuideHasData: false,
        assessments: null,
        assessmentsDict: null,
        assessmentsWeekDict: {},
        biology1SCStandardsDict: getSCBiology1Standards(),
        quizzes: [],
        quizzesForEndWeek: {},
        state: '',
        isV3: true,
        standardYears: null,
        prevYear: '-1',
        activeYear: '',
        pacingGuideMode: 'current',
        initialized: false,
        userSettingsInitialized: false,
        standardsProgress: null,
        standardsProgressSchoolsDict: null,
        currentWeek: -1,
        serverMoment: null,
        fetchingServerMoment: false,
        dayNumber: -1,
        dayName: '',
    }

    componentDidMount() {
        document.title = 'Pacing Guide & Lessons - Dot It';

        this.setState({
            setWeeksFunc: this.setWeeks,
            onStandardNameChangeFunc: this.onStandardNameChange,
            onStandardCategoryChangeFunc: this.onStandardCategoryChange,
            setStandardNameAndCategoryFunc: this.setStandardNameAndCategory,
            onSetActiveYearFunc: this.onSetActiveYear,
            onSetPacingGuideMode: this.onSetPacingGuideMode,
            setActiveSchoolFunc: this.setActiveSchoolFunc,
        })

        let weekNums = []
        for (let i = 0; i < this.state.totalWeeks; i++) {
            weekNums.push(i)
        }
        this.setState({
            weekNums: weekNums,
        })

        this.getData()

        this.setState({
            mounted: true,
        })

        this.prevPathname = this.props.history ? this.props.history.location.pathname : ''
        if (this.props.history) {
            this.unlistenHistory = this.props.history.listen((location) => {
                const nowOnGuide = location.pathname.includes('/guide')
                const wasOnGuide = this.prevPathname.includes('/guide')
                if (nowOnGuide && !wasOnGuide) {
                    this.scrollToCurrentWeek()
                }
                this.prevPathname = location.pathname
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        this.getData()
    }

    componentWillUnmount() {
        if (this.state.pacingGuideListener) {
            this.state.pacingGuideListener()
        }
        if (this.unlistenHistory) {
            this.unlistenHistory()
        }
    }

    tryUpdateUserSettings = () => {
        if (this.props.teacherBaseProps &&
            this.props.teacherBaseProps.user &&
            this.props.teacherBaseProps.user.id) {
            db.collection(ColType.userSettings)
                .doc(this.props.teacherBaseProps.user.id)
                .set({
                    pacingGuideStandardCategory: this.state.standardCategory,
                    pacingGuideStandardName: this.state.standardName,
                    updateTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
                }, { merge: true });
        }
    }

    setActiveSchoolFunc = (schoolId) => {
        this.setState({
            activeSchoolId: schoolId,
        }, () => {
            // this.getPacingGuideStats(schoolId, this.state.activeYear);
        })
    }

    onSetPacingGuideMode = (mode) => {
        let stateObj = {
            pacingGuideMode: mode,
        }

        // current year standard names do not have this future standardName, go back to K
        if (mode === 'current' &&
            this.state.standardNamesDict &&
            this.state.standardNamesDict.hasOwnProperty(this.state.standardCategory) &&
            this.state.standardNamesDict[this.state.standardCategory] &&
            !this.state.standardNamesDict[this.state.standardCategory].includes(this.state.standardName)) {
            stateObj.standardName = 'Kindergarten';
        } else if (mode === 'future' &&
            this.state.standardNamesDict &&
            this.state.standardNamesDict.hasOwnProperty('Future' + this.state.standardCategory) &&
            this.state.standardNamesDict['Future' + this.state.standardCategory] &&
            !this.state.standardNamesDict['Future' + this.state.standardCategory].includes(this.state.standardName)) {
            stateObj.standardName = 'Kindergarten';
        }

        this.setState(stateObj, () => {
            // a change in standardName occurred, get data
            if (stateObj.hasOwnProperty('standardName')) {
                this.getData()
            }
        });
    }

    onSetActiveYear = (year) => {
        this.setState({
            activeYear: year,
        }, () => {
            this.getData()
        })
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, () => resolve(this.state));
        });
    }

    getTeacherStandardsProgress = (pacingGuide, activeYear, currentWeek, currentDay) => {
        if (!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.teacher)) {
            return;
        }

        let standardsProgress = {};
        let promises = [];
        for (let i = 1; i < this.state.totalWeeks; i++) {
            let week = pacingGuide.weeks[i];
            week.forEach((standard) => {
                let standardKey = standard.standard;
                if (standardsProgress.hasOwnProperty(standardKey)) {
                    // already fetched this standard, skip
                    return;
                }
                if (!standardsProgress.hasOwnProperty(standardKey)) {
                    standardsProgress[standardKey] = null;
                }
                promises.push(new Promise((resolve, reject) => {
                    db.collection(ColType.teacherResourceProgress)
                        .doc(this.props.teacherBaseProps.teacher.id + '-' + standardKey + '-' + activeYear)
                        .get()
                        .then((doc) => {
                            if (doc.exists) {
                                let data = flattenDoc(doc);
                                let resourcesCount = 0;
                                let quizzesCount = 0;
                                let resourcesCompleted = 0;
                                let quizzesCompleted = 0;
                                let resourcesAverageScore = 0;
                                let quizzesAverageScore = 0;
                                Object.keys(data.resources).forEach((resourceId) => {
                                    let resource = data.resources[resourceId];
                                    let completed = 0;
                                    let averageScore = 0;

                                    Object.keys(resource.studentGrades).forEach((studentId) => {
                                        let studentGrade = resource.studentGrades[studentId];
                                        if (studentGrade.quizResults) {
                                            completed += 1;
                                            averageScore += studentGrade.quizResults.score / studentGrade.quizResults.total;
                                        }
                                    });

                                    if (completed > 0) {
                                        averageScore = averageScore / completed;
                                    }

                                    resource.completed = completed;
                                    resource.averageScore = averageScore;
                                    if (resource.resourceType === 'resource') {
                                        resourcesCount += 1;
                                        resourcesCompleted += completed;
                                        resourcesAverageScore += averageScore;
                                    } else if (resource.resourceType === 'quiz') {
                                        quizzesCount += 1;
                                        quizzesCompleted += completed;
                                        quizzesAverageScore += averageScore;
                                    }
                                });

                                if (resourcesCount > 0) {
                                    resourcesAverageScore = resourcesAverageScore / resourcesCount;
                                }
                                if (quizzesCount > 0) {
                                    quizzesAverageScore = quizzesAverageScore / quizzesCount;
                                }
                                data.resourcesCount = resourcesCount;
                                data.quizzesCount = quizzesCount;
                                data.resourcesCompleted = resourcesCompleted;
                                data.quizzesCompleted = quizzesCompleted;
                                data.resourcesAverageScore = resourcesAverageScore;
                                data.quizzesAverageScore = quizzesAverageScore;
                                data.resourcesCompletedPct = 0;
                                data.quizzesCompletedPct = 0;
                                data.totalCompleted = resourcesCompleted + quizzesCompleted;
                                data.totalCompletedPct = 0;
                                if (this.props.teacherBaseProps.students.length > 0) {
                                    data.resourcesCompletedPct = resourcesCompleted / this.props.teacherBaseProps.students.length;
                                }
                                if (this.props.teacherBaseProps.students.length > 0) {
                                    data.quizzesCompletedPct = quizzesCompleted / this.props.teacherBaseProps.students.length;
                                }
                                if (data.resourcesCount + data.quizzesCount > 0) {
                                    data.totalCompletedPct = (data.resourcesCompleted + data.quizzesCompleted) / this.props.teacherBaseProps.students.length;
                                }
                                standardsProgress[standardKey] = data;
                            }
                            resolve();
                        })
                        .catch((error) => {
                            resolve();
                        });
                }));
            });
        }

        return Promise.all(promises).then(() => {
            console.log('standardsProgress', standardsProgress)
            this.setState({
                standardsProgress: standardsProgress,
            });
        });
    }

    getAdminStandardsProgress = (pacingGuide, activeYear, currentWeek, currentDay) => {
        if (!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.admin &&
            this.props.teacherBaseProps.schools &&
            this.props.teacherBaseProps.schools.length > 0 &&
            this.props.teacherBaseProps.schoolsDict)) {
            return;
        }

        let standardsProgressSchoolsDict = {};
        this.props.teacherBaseProps.schools.forEach((school) => {
            standardsProgressSchoolsDict[school.id] = {
                school: school,
                onPace: false,
                totalResourcesCompleted: 0,
                totalResources: 0,
                totalQuizzesCompleted: 0,
                totalQuizzes: 0,
                totalCompleted: 0,
                total: 0,
                totalStudents: 0,
            }
        });

        let standardsProgress = {};
        let promises = [];
        for (let i = 1; i < this.state.totalWeeks; i++) {
            if (!pacingGuide.weeks || !pacingGuide.weeks[i]) {
                continue; // skip if week does not exist
            }
            let week = pacingGuide.weeks[i];
            let isCurrentWeek = (i === currentWeek);
            week.forEach((standard) => {
                let isCurrentDay = currentWeek === i &&
                    standard.days && standard.days.indexOf(currentDay) !== -1;
                let standardKey = standard.standard;
                if (standardsProgress.hasOwnProperty(standardKey)) {
                    // already fetched this standard, skip
                    return;
                }
                if (!standardsProgress.hasOwnProperty(standardKey)) {
                    standardsProgress[standardKey] = null;
                }
                promises.push(new Promise((resolve, reject) => {
                    db.collection(ColType.districtResourceProgress)
                        .doc(this.props.teacherBaseProps.admin.districtId + '-' + standardKey + '-' + activeYear)
                        .get()
                        .then((doc) => {
                            if (doc.exists) {
                                let data = flattenDoc(doc);
                                console.log(standardKey, data)
                                standardsProgress[standardKey] = data;
                                console.log('update standard progress', standardsProgress);

                                Object.keys(data.schoolGrades).forEach((schoolId) => {
                                    let schoolGrade = data.schoolGrades[schoolId];
                                    let schoolProgress = standardsProgressSchoolsDict[schoolId];
                                    schoolProgress.totalResources += schoolGrade.resourcesCount;
                                    schoolProgress.totalQuizzes += schoolGrade.quizzesCount;
                                    schoolProgress.totalResourcesCompleted += schoolGrade.resourcesCompleted;
                                    schoolProgress.totalQuizzesCompleted += schoolGrade.quizzesCompleted;
                                    schoolProgress.totalStudents = schoolGrade.studentCount;
                                });
                            }
                            resolve();
                        })
                        .catch((error) => {
                            resolve();
                        });
                }));
            });
        }

        return Promise.all(promises).then(() => {
            this.props.teacherBaseProps.schools.forEach((school) => {
                let schoolProgress = standardsProgressSchoolsDict[school.id];
                let resourcesPerStandard = 1;
                let quizzesPerStandard = 1;
                let totalCompleted = schoolProgress.totalResourcesCompleted +
                    schoolProgress.totalQuizzesCompleted;
                let total = resourcesPerStandard + quizzesPerStandard;
                let totalStudents = schoolProgress.totalStudents * total;
                let pctCompleted = 0;
                if (totalStudents > 0) {
                    pctCompleted = totalCompleted / totalStudents;
                }

                if (pctCompleted > 0.8) {
                    schoolProgress.onPace = true;
                }
            });
            console.log(standardsProgressSchoolsDict)
            this.setState({
                standardsProgress: standardsProgress,
                standardsProgressSchoolsDict: standardsProgressSchoolsDict,
            });
        });
    }

    /*getPacingGuideStats = (schoolId, activeYear) => {
        if (this.state.pacingGuideStats &&
            ((this.state.pacingGuideStats.type === 'district' && schoolId === 'district') ||
                (this.state.pacingGuideStats.type === 'school' &&
                    this.state.pacingGuideStats.schoolId === schoolId))) {
            return;
        }

        this.setState({
            pacingGuideStats: null,
        })

        let query = null;
        if (schoolId === 'district') {
            query = db.collection(ColType.pacingGuideStats)
                .where('districtId', '==', this.props.teacherBaseProps.district.id)
                .where('year', '==', activeYear)
                .where('type', '==', 'district')
                .limit(1)
                .get()
        } else {
            query = db.collection(ColType.pacingGuideStats)
                .where('districtId', '==', this.props.teacherBaseProps.district.id)
                .where('year', '==', activeYear)
                .where('type', '==', 'school')
                .where('schoolId', '==', schoolId)
                .limit(1)
                .get()
        }

        query.then((querySnapshot) => {
            let pacingGuideStats = null
            querySnapshot.forEach((doc) => {
                pacingGuideStats = flattenDoc(doc)
            })
            this.setState({
                pacingGuideStats: pacingGuideStats,
            });
        })
            .catch((error) => {
                console.error('Error on pacing guide stats get:', error)
            })
    }*/

    // Loads the week connections for the current subject and grade, keyed by
    // contentKey so a week can be matched against the district's own guide.
    // One query returns at most 36 documents.
    //
    // Deliberately silent on failure. These are supplementary, so a missing
    // read must look exactly like a district that has none: no card, no error,
    // nothing else on the page affected.
    getWeekConnections = (state, standardName, standardYear) => {
        db.collection(ColType.pacingGuideWeekConnections)
            .where('state', '==', state)
            .where('standardCategory', '==', this.state.standardCategory)
            .where('standardName', '==', standardName)
            .where('standardsYear', '==', standardYear)
            .get()
            .then((querySnapshot) => {
                let weekConnectionsDict = {}
                querySnapshot.forEach((doc) => {
                    let connection = flattenDoc(doc)
                    if (connection && connection.contentKey) {
                        weekConnectionsDict[connection.contentKey] = connection
                    }
                })
                this.setState({
                    weekConnectionsDict: weekConnectionsDict,
                })
            })
            .catch(() => {
                this.setState({
                    weekConnectionsDict: {},
                })
            })
    }

    getData = async () => {
        if (!(this.props.teacherBaseProps &&
            this.props.teacherBaseProps.user &&
            this.props.teacherBaseProps.district &&
            this.props.teacherBaseProps.districtSettings)) {
            return
        }
        if (this.props.teacherBaseProps.hasOwnProperty('admin') &&
            !(this.props.teacherBaseProps.admin &&
                this.props.teacherBaseProps.schools &&
                this.props.teacherBaseProps.schools.length > 0)) {
            return
        }
        if (this.props.teacherBaseProps.hasOwnProperty('instructionalFacilitator') &&
            !(this.props.teacherBaseProps.instructionalFacilitator &&
                this.props.teacherBaseProps.schools &&
                this.props.teacherBaseProps.schools.length > 0)
        ) {
            return
        }
        if (this.props.teacherBaseProps.hasOwnProperty('teacher') &&
            !(this.props.teacherBaseProps.teacher &&
                this.props.teacherBaseProps.school)) {
            return
        }

        if (!this.state.fetchingServerMoment) {
            this.setState({
                fetchingServerMoment: true,
            });
            getCurrentTimestamp(this.props.teacherBaseProps.user.id, 'SC')
                .then((pServerMoment) => {
                    this.setState({
                        serverMoment: pServerMoment.clone(),
                    });
                });
        }

        if (!this.state.userSettingsInitialized) {
            try {
                const userSettings = await db.collection(ColType.userSettings)
                    .doc(this.props.teacherBaseProps.user.id)
                    .get()
                if (userSettings.exists) {
                    const userSettingsData = flattenDoc(userSettings)
                    if (userSettingsData.hasOwnProperty('pacingGuideStandardCategory') &&
                        userSettingsData.hasOwnProperty('pacingGuideStandardName') &&
                        userSettingsData.pacingGuideStandardCategory &&
                        userSettingsData.pacingGuideStandardName) {
                        await this.setStateAsync({
                            standardCategory: userSettingsData.pacingGuideStandardCategory,
                            standardName: userSettingsData.pacingGuideStandardName,
                        });
                    }
                } else {

                }
            } catch (e) {
                //console.error(e)
            }
            this.setState({
                userSettingsInitialized: true,
            });
        }

        this.setState({
            state: this.props.teacherBaseProps.district.state,
        })

        if (Object.keys(this.state.standardNamesDict).length === 0) {
            this.setState({
                standardNamesDict: getStateStandardNamesDict(this.props.teacherBaseProps.district.state),
                standardCategories: getStateStandardCategories(this.props.teacherBaseProps.district.state)
            })
        }

        if (this.state.standardName === this.state.prevStandardName &&
            this.state.standardCategory === this.state.prevStandardCategory &&
            this.state.activeYear === this.state.prevYear) {
            return
        }

        this.setState({
            prevStandardName: this.state.standardName,
            prevStandardCategory: this.state.standardCategory,
            prevYear: this.state.activeYear,
        })

        const standardsColType = getStandardsColType(this.props.teacherBaseProps.district.state)
        //console.log(this.props.teacherBaseProps.district.state, standardsColType)

        if (this.state.pacingGuideListener) {
            this.state.pacingGuideListener()
            this.setState({
                pacingGuideListener: null,
            })
        }

        //https://storage.googleapis.com/pacingguidepdfs/64bec570267c8bfeea81f9ea/2026/Science_6th_Grade.pdf
        const standardCategoryForPDF = this.state.standardCategory.replaceAll(' ', '_');
        const standardNameForPDF = this.state.standardName.replaceAll(' ', '_');
        const pacingGuidePDF = `https://storage.googleapis.com/pacingguidepdfs/${this.props.teacherBaseProps.district.id}/2026/${standardCategoryForPDF}_${standardNameForPDF}.pdf`;
        this.setState({
            pacingGuidePDFURL: pacingGuidePDF,
        });

        let standardsSnapshot = null
        //console.log(this.props.teacherBaseProps.district)
        let state = this.props.teacherBaseProps.district.state
        // test district is NY, but we want SC standards
        if (state === 'NY') {
            state = 'SC'
        }

        let standardYears = this.state.standardYears
        let activeYear = this.state.activeYear
        if (!this.state.standardYears) {
            let doc = await db.collection(ColType.standardYears)
                .doc('all')
                .get()

            if (!doc.exists) {
                //console.log('standardYears doc does not exist')
                return
            }
            standardYears = flattenDoc(doc)
            activeYear = standardYears.currentYear
            this.setState({
                standardYears: standardYears,
                activeYear: standardYears.currentYear,
            })
        }

        const stateAndStandardCategory = state + this.state.standardCategory
        if (!standardYears.hasOwnProperty(stateAndStandardCategory)) {
            console.error('standardYears does not have key', stateAndStandardCategory)
            return
        }
        let standardYear = standardYears[stateAndStandardCategory]
        let standardName = this.state.standardName
        // KY ELA standards are 9-10 and 11-12
        if (state === 'KY' && this.state.standardCategory === 'ELA') {
            if (standardName === '10th Grade') {
                //    standardName = '9th Grade'
            } else if (standardName === '12th Grade') {
                //  standardName = '11th Grade'
            }
        }

        /*if (this.props.teacherBaseProps.district.id !== '64bec570267c8bfeea81f9ea' &&
            this.state.standardCategory === 'Math' &&
            state === 'SC') {
            db.collection(ColType.standards)
                .where('state', '==', state)
                .where('standardName', '==', standardName)
                .where('standardCategory', '==', this.state.standardCategory)
                .where('year', '==', '2023')
                .orderBy('sortOrder')
                .get()
                .then((querySnapshot) => {
                    let futureStandards = []
                    let futureStandardsDict = {}
                    querySnapshot.forEach((doc) => {
                        let standard = flattenDoc(doc)
                        futureStandards.push(standard)
                        futureStandardsDict[standard.standard] = standard
                    })
                    //console.log('futureStandards', futureStandards)
                    this.setState({
                        futureStandards: futureStandards,
                        futureStandardsDict: futureStandardsDict,
                    }, () => {
                        db.collection(ColType.futurePacingGuides)
                            .where('standardName', '==', this.state.standardName)
                            .where('standardCategory', '==', this.state.standardCategory)
                            .get()
                            .then((querySnapshot) => {
                                let futurePacingGuide = null
                                querySnapshot.forEach((doc) => {
                                    futurePacingGuide = flattenDoc(doc)
                                })
                                //console.log('futurePacingGuide', futurePacingGuide)
                                if (futurePacingGuide) {
                                    // add standards to week 0
                                    let weeks = futurePacingGuide.weeks
                                    weeks[0] = []
                                    for (let standard of futureStandards) {
                                        weeks[0].push(standard)
                                    }
                                }
                                let pacingGuideMode = this.state.pacingGuideMode
                                if (!futurePacingGuide && pacingGuideMode === 'future') {
                                    pacingGuideMode = 'current'
                                }
                                this.setState({
                                    futurePacingGuide: futurePacingGuide,
                                    pacingGuideMode: pacingGuideMode,
                                })
                            })
                    })
                })
        } else {
            // clear future standards
            this.setState({
                pacingGuideMode: 'current',
                futurePacingGuide: null,
                futureStandards: [],
                futureStandardsDict: {},
            })
        }*/
        //console.log(state, standardName, this.state.standardCategory, standardYear)
        db.collection(ColType.standards)
            .where('state', '==', state)
            .where('standardName', '==', standardName)
            .where('standardCategory', '==', this.state.standardCategory)
            .where('year', '==', standardYear)
            .orderBy('sortOrder')
            .get()
            .then((standardsSnapshot) => {
                let standards = []
                let standardsDict = {}
                standardsSnapshot.forEach((doc) => {
                    let standard = flattenDoc(doc)
                    standards.push(standard)
                    standardsDict[standard.standard] = standard
                })
                //console.log('standards', standards, standardsDict)
                this.setState({
                    standards: standards,
                    standardsDict: standardsDict,
                });
            });

        if (this.state.activeSchoolId === '') {
            let initialActiveSchoolId = 'district';
            if (!this.props.teacherBaseProps.hasOwnProperty('admin')) {
                if (this.props.teacherBaseProps.hasOwnProperty('instructionalFacilitator') &&
                    this.props.teacherBaseProps.schools &&
                    this.props.teacherBaseProps.schools.length > 0) {
                    initialActiveSchoolId = this.props.teacherBaseProps.schools[0].id;
                } else if (this.props.teacherBaseProps.hasOwnProperty('teacher') &&
                    this.props.teacherBaseProps.school) {
                    initialActiveSchoolId = this.props.teacherBaseProps.school.id;
                }
            }
            this.setState({
                activeSchoolId: initialActiveSchoolId,
            }, () => {
                // this.getPacingGuideStats(this.state.activeSchoolId, activeYear);
            })
        } else {
            //this.getPacingGuideStats(this.state.activeSchoolId, activeYear);
        }

        // Week connections are optional reference content. Fetch them on their
        // own so nothing else on this page depends on the result: a district
        // with none generated, a week with a single standard, and a failed read
        // all land in the same place, an empty dict and no card.
        this.getWeekConnections(state, standardName, standardYear)

        //console.log(standardYear, standardName, state, this.state.standardCategories, standards)
        //console.log(this.props.teacherBaseProps.district.id, activeYear)
        let pacingGuideListener = db.collection(ColType.pacingGuides)
            .where('standardName', '==', this.state.standardName)
            .where('standardCategory', '==', this.state.standardCategory)
            .where('districtId', '==', this.props.teacherBaseProps.district.id)
            .where('year', '==', activeYear)
            .limit(20)
            .onSnapshot((querySnapshot) => {
                if (querySnapshot.empty) {
                    // pacing guides are created ahead of time
                    console.error('pacing guide does not exist')
                    // set pacing guide to empty
                    this.setState({
                        initialized: true,
                        pacingGuide: null,
                    })
                    return
                }
                if (querySnapshot.docs.length > 1) {
                    console.error('more than one pacing guide exists', querySnapshot.docs.length)
                }

                let pacingGuide = flattenDoc(querySnapshot.docs[0])

                // Derived from this district's guide, before week 0 is filled
                // with the full standard list below. Wrapped because a
                // malformed guide must not stop the guide itself rendering.
                try {
                    this.setState({
                        weekConnectionKeys: getWeekConnectionKeys(pacingGuide.weeks),
                    })
                } catch (e) {
                    this.setState({ weekConnectionKeys: {} })
                }

                const POSSIBLE_DAY_STRINGS = {
                    // multi‐day ranges
                    'Mon-Fri': 'Monday, Tuesday, Wednesday, Thursday, Friday',
                    'Mon-Wed': 'Monday, Tuesday, Wednesday',
                    'Mon-Tues': 'Monday, Tuesday',
                    'Tues-Wed': 'Tuesday, Wednesday',
                    'Thurs-Fri': 'Thursday, Friday',

                    // single weekdays
                    'Monday': 'Monday',
                    'Tuesday': 'Tuesday',
                    'Wednesday': 'Wednesday',
                    'Thursday': 'Thursday',
                    'Friday': 'Friday',
                };
                for (let i = 1; i < this.state.totalWeeks; i++) {
                    let week = pacingGuide.weeks[i];
                    week.forEach((standard, index) => {
                        let day = getPacingGuideWeekIndexDay(week, index);
                        standard.day = day;
                        standard.days = POSSIBLE_DAY_STRINGS[day] || day;
                    });
                }

                let pacingGuideHasData = true;
                let scheduledStandardsDict = {};
                if (this.state.standards &&
                    this.state.standardsDict &&
                    this.state.standards.length > 0 &&
                    this.state.standards[0].standardName === pacingGuide.standardName &&
                    this.state.standards[0].standardCategory === pacingGuide.standardCategory) {
                    let standards = this.state.standards;
                    let standardsDict = this.state.standardsDict;
                    // always set week[0] to standards as they may have changed
                    let weeks = pacingGuide.weeks
                    weeks[0] = []
                    for (let standard of standards) {
                        weeks[0].push(standard)
                    }

                    // skip week 0 (side menu)
                    for (let i = 1; i < this.state.totalWeeks; i++) {
                        let scheduledStandards = weeks[i]
                        if (scheduledStandards.length > 0) {
                            pacingGuideHasData = true
                        }
                        for (let standard of scheduledStandards) {
                            let key = standard.standard
                            // if the scheduled standard is not in the side menu standards,
                            // continue (this is to handle Biology standards in Earth Science)
                            // Biology standards won't be in the side menu standards for Earth Science
                            if (!standardsDict.hasOwnProperty(key)) {
                                continue
                            }
                            if (!scheduledStandardsDict.hasOwnProperty(key)) {
                                scheduledStandardsDict[key] = 0
                            }
                            scheduledStandardsDict[key] += 1
                        }
                    }
                }

                //console.log(pacingGuide)

                this.setState({
                    initialized: true,
                    pacingGuide: pacingGuide,
                    pacingGuideHasData: true,
                    scheduledStandardsDict: scheduledStandardsDict,
                }, () => {
                    if (this.state.currentWeek === -1) {
                        // initially set to -2 to stop repeat calls
                        this.setState({
                            currentWeek: -2,
                        });
                        const setCurrentWeek = (pServerMoment) => {
                            if (!pServerMoment) {
                                return;
                            }
                            const serverMoment = pServerMoment.clone();
                            let yearStart = '2025-08-04';
                            if (this.props.teacherBaseProps &&
                                this.props.teacherBaseProps.districtSettings &&
                                this.props.teacherBaseProps.districtSettings.hasOwnProperty('yearStart')) {
                                yearStart = this.props.teacherBaseProps.districtSettings.yearStart;
                            }
                            let currentWeek = getSchoolWeekNumber(serverMoment, yearStart);
                            const dayNumber = serverMoment.isoWeekday();
                            const dayName = serverMoment.format('dddd');
                            this.setState({
                                currentWeek: currentWeek,
                                dayNumber: dayNumber,
                                dayName: dayName,
                            });

                            this.scrollToCurrentWeek(currentWeek);


                            /*
                            if (this.props.teacherBaseProps && this.props.teacherBaseProps.teacher &&
                                this.props.teacherBaseProps.teacher.districtId === '64bec570267c8bfeea81f9ea'
                            ) {
                                this.getTeacherStandardsProgress(pacingGuide, activeYear, currentWeek, dayName);
                            } else if (this.props.teacherBaseProps && this.props.teacherBaseProps.admin &&
                                this.props.teacherBaseProps.admin.districtId === '64bec570267c8bfeea81f9ea'
                            ) {
                                this.getAdminStandardsProgress(pacingGuide, activeYear, currentWeek, dayName);
                            }*/
                        };

                        // use the server moment if it was retrieved already above to make
                        // the load time faster.
                        if (this.state.serverMoment) {
                            setCurrentWeek(this.state.serverMoment);
                        } else {
                            // hasn't loaded yet, get it now
                            getCurrentTimestamp(this.props.teacherBaseProps.user.id, 'SC')
                                .then((pServerMoment) => {
                                    setCurrentWeek(pServerMoment);
                                    this.setState({
                                        serverMoment: pServerMoment.clone(),
                                    });
                                });
                        }
                    }
                });
            })

        this.setState({
            pacingGuideListener: pacingGuideListener,
        });

        if (!(this.props.teacherBaseProps.district.id.startsWith('demo_'))) {
            //console.log('activeYear', activeYear);
            db.collection(ColType.quizzes)
                .where('standardName', '==', this.state.standardName)
                .where('standardCategory', '==', this.state.standardCategory)
                .where('districtId', '==', this.props.teacherBaseProps.district.id)
                //.where('queryId', '==', this.props.teacherBaseProps.district.id)
                .where('year', '==', activeYear)
                .where('live', '==', true)
                .orderBy('createdAt', 'desc')
                .get()
                .then((querySnapshot) => {
                    let quizzes = []
                    let quizzesForEndWeek = {}
                    //console.log('quizzes querySnapshot', querySnapshot.docs)
                    querySnapshot.forEach((doc) => {
                        let quiz = flattenDoc(doc)
                        //console.log('quiz', quiz)
                        if (quiz.hasOwnProperty('version') &&
                            (quiz.version === '3.0' ||
                                quiz.version === '4.0')
                        ) {
                            quizzes.push(quiz)
                            let endWeek = quiz.endWeek + 1;
                            if (endWeek > 36) {
                                endWeek = 36;
                            }
                            if (!quizzesForEndWeek.hasOwnProperty(endWeek)) {
                                quizzesForEndWeek[endWeek] = []
                            }
                            quizzesForEndWeek[endWeek].push(quiz)
                        } else {
                            quiz.docs = JSON.parse(quiz.docs)
                            // shuffle questions
                            quiz.docs.map((doc) => {
                                try {
                                    // will throw error here before shuffle, determining if format is correct
                                    let answers = doc.components[0].answers
                                    // format is known, shuffle
                                    doc.components[0].answers = shuffleArray(doc.components[0].answers)
                                } catch (e) {
                                    // pass
                                    return false
                                }
                            })

                            quizzes.push(quiz)
                            if (!quizzesForEndWeek.hasOwnProperty(quiz.endWeek)) {
                                quizzesForEndWeek[quiz.endWeek] = []
                            }
                            quizzesForEndWeek[quiz.endWeek].push(quiz)
                        }
                    })

                    Object.keys(quizzesForEndWeek).map((key) => {
                        quizzesForEndWeek[key].sort((a, b) => {
                            if (a.hasOwnProperty('assessmentTitle') &&
                                b.hasOwnProperty('assessmentTitle')) {
                                if (a.assessmentTitle < b.assessmentTitle) {
                                    return -1
                                } else if (a.assessmentTitle > b.assessmentTitle) {
                                    return 1
                                }

                                return 0
                            }

                            return 0
                        })

                        return false
                    })

                    this.setState({
                        quizzes: quizzes,
                        quizzesForEndWeek: quizzesForEndWeek,
                    })
                    //console.log('quizzes', quizzes, quizzesForEndWeek)
                })
        }
    }

    scrollToCurrentWeek = (week) => {
        const currentWeek = (typeof week === 'number') ? week : this.state.currentWeek
        if (typeof currentWeek !== 'number' || currentWeek < 0) return

        let attempts = 0
        const tryScroll = () => {
            const element = document.getElementById('week-' + currentWeek)
            if (element) {
                const offset = 100
                const elementPosition = element.getBoundingClientRect().top + window.scrollY - offset
                window.scrollTo({ top: elementPosition })
                return
            }
            if (attempts++ < 30) setTimeout(tryScroll, 100)
        }
        tryScroll()
    }

    getBiologyStandards = () => {
        const standardsColType = getStandardsColType(this.props.teacherBaseProps.district.state)

        db.collection(standardsColType)
            .where('standardName', '==', 'Biology')
            .where('standardCategory', '==', 'Science')
            .orderBy('sortOrder')
            .get()
            .then((querySnapshot) => {
                let standards = []
                let standardsDict = {}
                querySnapshot.forEach((doc) => {
                    let standard = flattenDoc(doc)
                    standards.push(standard)
                    standardsDict[standard.standard] = standard
                })

                let pacingGuide = this.state.pacingGuide
                for (let standard of standards) {
                    pacingGuide.weeks[0].push(standard)
                }
                this.setState({
                    pacingGuide: pacingGuide,
                })
            })
    }

    filterOutBiology2Standards = () => {
        if (this.state.standardName === 'Biology') {
            let pacingGuide = this.state.pacingGuide
            for (let i = 1; i < this.state.totalWeeks; i++) {
                let standards = pacingGuide.weeks[i]
                let filteredStandards = []
                for (let standard of standards) {
                    if (this.state.biology1SCStandardsDict.hasOwnProperty(standard.standard)) {
                        filteredStandards.push(standard)
                    }
                }
                pacingGuide.weeks[i] = filteredStandards
            }
            this.setState({
                pacingGuide: pacingGuide,
            })
        }
    }

    setStandards = (standards) => {
        this.setStandards({
            standards: standards,
        })
    }

    onStandardNameChange = (value) => {
        this.setState({
            standardName: value,
        }, () => {
            this.getData()
            this.tryUpdateUserSettings()
        })
    }

    onStandardCategoryChange = (value) => {
        let stateObj = { standardCategory: value }
        if (!this.state.gradeDictAcrossCategories.hasOwnProperty(this.state.standardName)) {
            stateObj.standardName = 'Kindergarten'
        }
        this.setState(stateObj, () => {
            this.getData()
            this.tryUpdateUserSettings()
        })
    }

    setStandardNameAndCategory = (standardName, standardCategory) => {
        let stateObj = {
            standardName: standardName,
            standardCategory: standardCategory,
        }
        if (!this.state.gradeDictAcrossCategories.hasOwnProperty(standardName)) {
            stateObj.standardName = 'Kindergarten'
        }
        this.setState(stateObj, () => {
            this.getData()
        })
    }

    setWeeks = (weeks) => {
        if (this.state.pacingGuide) {
            // set immediately so that there is no visual delay
            // when the db update below finishes, the listener
            // will also update
            let pacingGuide = this.state.pacingGuide
            pacingGuide.weeks = weeks
            this.setState({
                pacingGuide: pacingGuide,
            })

            // Make a shallow copy of the object
            let weeksToDB = Object.assign({}, weeks);
            // Delete the first property (standards list that is
            // added in the onSnapshot listener on each update)
            // save space by not adding to db
            delete weeksToDB[0];

            db.collection(ColType.pacingGuides)
                .doc(this.state.pacingGuide.id)
                .update({
                    weeks: weeksToDB,
                })
        }
    }

    isStandardScheduled = (weeks, standard) => {
        for (let i = 1; i < this.state.totalWeeks; i++) {
            const standards = weeks[i]
            for (let j = 0; j < standards.length; j++) {
                const standardInternal = standards[j]
                if (standardInternal.standard === standard.standard) {
                    return true
                }
            }
        }
        return false
    }

    updatePacingGuideStandards = () => {
        // updates the pacing guide standards with the latest standards
        // based on the standard.standard
        if (!this.state.pacingGuide) {
            return
        }
        if (!this.state.standardsDict) {
            return
        }
        let weeks = {}
        for (let i = 0; i < this.state.totalWeeks; i++) {
            weeks[i] = []
        }
        for (let i = 1; i < this.state.totalWeeks; i++) {
            let standards = this.state.pacingGuide.weeks[i]
            for (let standard of standards) {
                if (!this.state.standardsDict.hasOwnProperty(standard.standard)) {
                    console.error('standard not found', standard.standard, 'not adding');
                    //return;
                    continue;
                }

                // add newer version of the standard
                weeks[i].push(this.state.standardsDict[standard.standard])
            }
        }

        console.log('updated');
        this.setWeeks(weeks);
    }

    setPacingGuideWithPresetStandards = () => {
        let pacingGuideStandardsDict = {
            // Place Value, Decimals, and Addition/Subtraction (weeks 1–5)
            1: ["KY.4.NBT.1"],                                                  // Mon-Fri
            2: ["KY.4.NBT.2.a", "KY.4.NBT.2.b"],                                // Mon-Wed | Thurs-Fri
            3: ["KY.4.NBT.3", "KY.4.NF.6"],                                     // Mon-Wed | Thurs-Fri
            4: ["KY.4.NF.7.a", "KY.4.NF.7.b", "KY.4.NF.7.c"],                   // Mon-Tues | Wed | Thurs-Fri
            5: ["KY.4.NBT.4"],                                                  // Mon-Fri

            // Word Problems, Area/Perimeter, and Fluency (weeks 6–8)
            6: ["KY.4.OA.2.b"],                                                 // Mon-Fri
            7: ["KY.4.MD.3"],                                                   // Mon-Fri
            8: ["KY.4.NBT.4"],                                                  // Mon-Fri

            // Operations and Algebraic Thinking (weeks 9–13)
            9: ["KY.4.OA.4.a", "KY.4.OA.4.b"],                                  // Mon-Wed | Thurs-Fri
            10: ["KY.4.OA.4.c", "KY.4.OA.4.d"],                                 // Mon-Wed | Thurs-Fri
            11: ["KY.4.OA.5", "KY.4.OA.1"],                                     // Mon-Wed | Thurs-Fri
            12: ["KY.4.OA.2.b", "KY.4.OA.3.b"],                                 // Mon-Wed | Thurs-Fri
            13: ["KY.4.OA.2.a", "KY.4.OA.3.a"],                                 // Mon-Wed | Thurs-Fri

            // Multiplication and Division (weeks 14–16)
            14: ["KY.4.NBT.5"],                                                 // Mon-Fri
            15: ["KY.4.NBT.6"],                                                 // Mon-Fri
            16: ["KY.4.MD.3", "KY.4.OA.2.b"],                                   // Mon-Wed | Thurs-Fri

            // Number and Operations – Fractions (weeks 17–24)
            17: ["KY.4.NF.1.a"],                                                // Mon-Fri
            18: ["KY.4.NF.1.b"],                                                // Mon-Fri
            19: ["KY.4.NF.2"],                                                  // Mon-Fri
            20: ["KY.4.NF.2"],                                                  // Mon-Fri
            21: ["KY.4.NF.3.a", "KY.4.NF.3.b"],                                 // Mon-Wed | Thurs-Fri
            22: ["KY.4.NF.3.c", "KY.4.NF.3.d"],                                 // Mon-Wed | Thurs-Fri
            23: ["KY.4.NF.4.a", "KY.4.NF.4.b", "KY.4.NF.4.c"],                  // Mon-Tues | Wed | Thurs-Fri
            24: ["KY.4.NF.5.a", "KY.4.NF.5.b", "KY.4.MD.4.a", "KY.4.MD.4.b", "KY.4.MD.4.c"], // Mon | Tue | Wed | Thu | Fri

            // Geometry (weeks 25–26)
            25: ["KY.4.G.1"],                                                   // Mon-Fri
            26: ["KY.4.G.2", "KY.4.G.3.a", "KY.4.G.3.b"],                       // Mon-Tues | Wed | Thurs-Fri

            // Measurement and Data – Angles (weeks 27–28)
            27: ["KY.4.MD.5", "KY.4.MD.6"],                                     // Mon-Wed | Thurs-Fri
            28: ["KY.4.MD.7"],                                                  // Mon-Fri

            // Measurement and Data (weeks 29–32)
            29: ["KY.4.MD.1.a", "KY.4.MD.1.b"],                                 // Mon-Wed | Thurs-Fri
            30: ["KY.4.MD.1.c"],                                                // Mon-Fri
            31: ["KY.4.MD.2.a", "KY.4.MD.2.b"],                                 // Mon-Wed | Thurs-Fri
            32: ["KY.4.MD.2.c"],                                                // Mon-Fri

            // Review (weeks 33–36)
            33: ["KY.4.NBT.1", "KY.4.NBT.2.a", "KY.4.NBT.3", "KY.4.NF.7.a", "KY.4.OA.2.b", "KY.4.MD.3", "KY.4.NBT.4"], // Mon | Tue | Tue | Wed | Wed | Thu | Fri
            34: ["KY.4.OA.4.a", "KY.4.OA.5", "KY.4.OA.2.a", "KY.4.NBT.5", "KY.4.NBT.6"],                            // Mon | Tue | Wed | Thu | Fri
            35: ["KY.4.NF.1.a", "KY.4.NF.2", "KY.4.NF.3.a", "KY.4.NF.4.a", "KY.4.NF.5.a", "KY.4.MD.4.a"],           // Mon | Tue | Tue | Wed | Thu | Fri
            36: ["KY.4.G.1", "KY.4.G.2", "KY.4.MD.5", "KY.4.MD.1.a", "KY.4.MD.2.a", "KY.4.NBT.4"]                   // Mon | Tue | Tue | Wed | Thu | Fri
        };

        function dedupPacingGuide(pacingGuide) {
            const dedupedGuide = {};

            for (const [week, standards] of Object.entries(pacingGuide)) {
                dedupedGuide[week] = [...new Set(standards)];
            }

            return dedupedGuide;
        }

        // remove duplicate standard names from each week if they exist
        pacingGuideStandardsDict = dedupPacingGuide(pacingGuideStandardsDict);

        // ensure all standards exist in standardsDict
        for (let week in pacingGuideStandardsDict) {
            for (let standard of pacingGuideStandardsDict[week]) {
                if (!this.state.standardsDict.hasOwnProperty(standard)) {
                    console.error('standard does not exist', standard)
                    return
                }
            }
        }

        // sort by category
        /*for (let week in pacingGuideStandardsDict) {
            pacingGuideStandardsDict[week].sort((a, b) => {
                if (a.includes('RL') && !b.includes('RL')) {
                    return -1;
                }
                if (!a.includes('RL') && b.includes('RL')) {
                    return 1;
                }
                if (a.includes('RL') && b.includes('RL')) {
                    return a.localeCompare(b);
                }
                if (a.includes('RI') && !b.includes('RI')) {
                    return -1;
                }
                if (!a.includes('RI') && b.includes('RI')) {
                    return 1;
                }
                if (a.includes('RI') && b.includes('RI')) {
                    return a.localeCompare(b);
                }
                // AOR > C > F > R
                if (a.includes('AOR') && !b.includes('AOR')) {
                    return -1;
                }
                if (!a.includes('AOR') && b.includes('AOR')) {
                    return 1;
                }
                if (a.includes('C') && !b.includes('C')) {
                    return -1;
                }
                if (!a.includes('C') && b.includes('C')) {
                    return 1;
                }
                if (a.includes('C') && b.includes('C')) {
                    return a.localeCompare(b);
                }
                if (a.includes('F') && !b.includes('F')) {
                    return -1;
                }
                if (!a.includes('F') && b.includes('F')) {
                    return 1;
                }
                if (a.includes('R') && !b.includes('R')) {
                    return -1;
                }
                if (!a.includes('R') && b.includes('R')) {
                    return 1;
                }

                // both have AOR, string split and convert [3] to number and compare, if the same, lexical
                if (a.includes('AOR') && b.includes('AOR')) {
                    let partsA = a.split('.');
                    let partsB = b.split('.');
                    if (partsA.length > 3 && partsB.length > 3) {
                        let numA = parseInt(partsA[3]);
                        let numB = parseInt(partsB[3]);
                        if (numA !== numB) {
                            return numA - numB;
                        }
                    }
                }
                return a.localeCompare(b);
            });
        }*/

        let standardsScheduled = {}
        let weeks = {}
        for (let i = 0; i < this.state.totalWeeks; i++) {
            weeks[i] = []
        }

        for (let week in pacingGuideStandardsDict) {
            for (let standard of pacingGuideStandardsDict[week]) {
                weeks[parseInt(week)].push(this.state.standardsDict[standard])
                standardsScheduled[standard] = true
            }
        }

        // console.log if not all standards are scheduled
        let notAllScheduled = false
        for (let i = 0; i < this.state.standards.length; i++) {
            const standard = this.state.standards[i].standard
            if (!standardsScheduled.hasOwnProperty(standard)) {
                console.error('standard not scheduled', standard)
                notAllScheduled = true
            }
        }

        if (notAllScheduled) {
            console.error('not all standards scheduled, returning');
            return;
        }

        console.log('all standards scheduled, all standards exist');

        this.setWeeks(weeks);
    }

    /*setDefaultPacingGuide = () => {
        if (this.state.standards.length === 0) {
            return;
        }

        let standards = JSON.parse(JSON.stringify(this.state.standards));

        // Group the standards by their category
        const groupedStandards = standards.reduce((acc, curr) => {
            // ELA is [0], ELA K-2 is [2], Math is [1], change for the subject and grade level
            let category = curr.standard.split('.');
            category = category[1]

            if (!acc[category]) {
                acc[category] = [];
            }
            acc[category].push(curr);
            return acc;
        }, {});

        // Sort each group
        for (const category in groupedStandards) {
            groupedStandards[category].sort((a, b) => {
                const partsA = a.standard.split('.');
                const partsB = b.standard.split('.');
                for (let i = 1; i < Math.min(partsA.length, partsB.length); i++) {
                    if (partsA[i] !== partsB[i]) {
                        if (isNaN(partsA[i]) || isNaN(partsB[i])) {
                            return partsA[i].localeCompare(partsB[i]);
                        }
                        return parseInt(partsA[i]) - parseInt(partsB[i]);
                    }
                }
                return partsA.length - partsB.length;
            });
        }

        console.log(groupedStandards)

        const weeks = Array.from({ length: 37 }, () => []);

        // Distribute each standard to cover all 36 weeks
        for (const category in groupedStandards) {
            let categoryStandards = groupedStandards[category];
            let numStandards = categoryStandards.length;
            let distributionSpan = Math.floor(36 / numStandards); // Span of weeks for each standard
            if (numStandards > 36) {
                distributionSpan = 1;
            }
            console.log(category, distributionSpan)
            if (distributionSpan > 30) {
                //distributionSpan /= 10;
                //distributionSpan = Math.floor(distributionSpan);
            }
            let weekIdx = 1;
            for (let i = 0; i < numStandards; i++) {
                let standard = categoryStandards[i];
                if (weekIdx + distributionSpan > 36) {
                    const weeksLeft = 36 - weekIdx + 1;
                    for (let j = 0; j < weeksLeft; j++) {
                        weeks[weekIdx + j].push(standard);
                    }
                    for (let standard of categoryStandards) {
                        if (this.isStandardScheduled(weeks, standard)) {
                            continue;
                        }
                        weeks[36].push(standard);
                    }
                    break;
                }
                for (let j = 0; j < distributionSpan; j++) {
                    const week = weekIdx + j;
                    if (week > 36) {
                        break;
                    }
                    weeks[week].push(standard);
                    if (category === 'RL' ||
                        category === 'RI' ||
                        category === 'F' ||
                        category === 'AOR' ||
                        category === 'NS' ||
                        category === 'ATO' ||
                        category === 'NSBT' ||
                        category === 'G' ||
                        category === 'H' ||
                        category == 'AG' ||
                        category == 'ER' ||
                        category == 'PS4' ||
                        category === 'LS1') {
                        if ((distributionSpan === 1 && i < numStandards - 1) ||
                            (j > 0 && i < numStandards - 1)) {
                            //(numStandards > 36 && i < numStandards - 1)) {
                            weeks[week].push(categoryStandards[i + 1]);
                        }
                    }
                }
                weekIdx += distributionSpan;
            }
        }

        for (let i = 1; i < 37; i++) {
            weeks[i].sort((a, b) => {
                // RL, RI, W, I, C
                let partsA = a.standard.split('.');
                let partsB = b.standard.split('.');
                if (partsA[0] === 'RL' && partsB[0] !== 'RL') {
                    return -1;
                } else if (partsA[0] !== 'RL' && partsB[0] === 'RL') {
                    return 1;
                } else if (partsA[0] === 'RI' && partsB[0] !== 'RI') {
                    return -1;
                } else if (partsA[0] !== 'RI' && partsB[0] === 'RI') {
                    return 1;
                } else if (partsA[0] === 'W' && partsB[0] !== 'W') {
                    return -1;
                } else if (partsA[0] !== 'W' && partsB[0] === 'W') {
                    return 1;
                } else if (partsA[0] === 'I' && partsB[0] !== 'I') {
                    return -1;
                } else if (partsA[0] !== 'I' && partsB[0] === 'I') {
                    return 1;
                } else if (partsA[0] === 'C' && partsB[0] !== 'C') {
                    return -1;
                } else if (partsA[0] !== 'C' && partsB[0] === 'C') {
                    return 1;
                }

                partsA = a.standard.split('.')[1];
                partsB = b.standard.split('.')[1];
                if (partsA === 'ATO' && partsB !== 'ATO') {
                    return -1;
                } else if (partsA !== 'ATO' && partsB === 'ATO') {
                    return 1;
                } else if (partsA === 'NSBT' && partsB !== 'NSBT') {
                    return -1;
                } else if (partsA !== 'NSBT' && partsB === 'NSBT') {
                    return 1;
                } else if (partsA === 'G' && partsB !== 'G') {
                    return -1;
                } else if (partsA !== 'G' && partsB === 'G') {
                    return 1;
                } else {
                    return 0;
                }

                return 0;
            });
        }

        weeks[0] = JSON.parse(JSON.stringify(standards)); // Optionally keep a copy of all standards
        this.setWeeks(weeks);
    }*/

    setFuturePacingGuide = () => {
        if (!this.state.futureStandards ||
            this.state.futureStandards.length === 0 ||
            !this.state.futureStandardsDict) {
            return;
        }

        let pacingGuideStandardsDict = {
            // Unit 1: Area and Surface Area (4 weeks)
            1: ["KY.6.G.1", "KY.6.EE.2.a", "KY.6.EE.2.c"],
            2: ["KY.6.G.1", "KY.6.EE.2.a", "KY.6.EE.2.c", "KY.6.G.4"],
            3: ["KY.6.G.1", "KY.6.G.4", "KY.6.G.2"],
            4: ["KY.6.G.1", "KY.6.G.4", "KY.6.EE.1", "KY.6.EE.2.a"],

            // Unit 2: Introducing Ratios (4 weeks)
            5: ["KY.6.RP.1"],
            6: ["KY.6.RP.1", "KY.6.RP.3.a"],
            7: ["KY.6.RP.3.a", "KY.6.RP.3.b"],
            8: ["KY.6.RP.2", "KY.6.RP.3.a", "KY.6.RP.3.b"],

            // Unit 3: Unit Rate and Percentages (4 weeks)
            9: ["KY.6.RP.2", "KY.6.RP.3.b"],
            10: ["KY.6.RP.2", "KY.6.RP.3.b"],
            11: ["KY.6.RP.3.c"],
            12: ["KY.6.RP.3.c"],

            // Unit 4: Dividing Fractions (4 weeks)
            13: ["KY.6.NS.1"],
            14: ["KY.6.NS.1", "KY.6.G.1", "KY.6.G.2"],
            15: ["KY.6.NS.1", "KY.6.G.2"],
            16: ["KY.6.NS.1"],

            // Unit 5: Arithmetic in Base Ten (4 weeks)
            17: ["KY.6.NS.3"],
            18: ["KY.6.NS.2.a", "KY.6.NS.2.b", "KY.6.NS.3"],
            19: ["KY.6.NS.2.a", "KY.6.NS.2.b", "KY.6.NS.3"],
            20: ["KY.6.EE.4", "KY.6.NS.3"],

            // Unit 6: Expressions and Equations (4 weeks)
            21: ["KY.6.EE.5", "KY.6.EE.6", "KY.6.EE.7"],
            22: ["KY.6.EE.2.a", "KY.6.EE.2.c", "KY.6.EE.6", "KY.6.EE.4"],
            23: ["KY.6.EE.1", "KY.6.EE.2.b", "KY.6.EE.3"],
            24: ["KY.6.EE.1", "KY.6.EE.2.c", "KY.6.EE.5", "KY.6.EE.9.a", "KY.6.EE.9.b", "KY.6.EE.9.c"],

            // Unit 7: Rational Numbers (4 weeks)
            25: ["KY.6.NS.5", "KY.6.NS.6.a", "KY.6.NS.7.a"],
            26: ["KY.6.NS.7.b", "KY.6.NS.5"],
            27: ["KY.6.NS.7.c", "KY.6.NS.7.d", "KY.6.NS.6.a", "KY.6.EE.8"],
            28: ["KY.6.NS.6.b", "KY.6.NS.6.c", "KY.6.NS.8", "KY.6.G.3", "KY.6.NS.4"],

            // Unit 8: Data Sets and Distributions (4 weeks)
            29: ["KY.6.SP.0.a", "KY.6.SP.0.b", "KY.6.SP.1", "KY.6.SP.5.b"],
            30: ["KY.6.SP.2", "KY.6.SP.0.c", "KY.6.SP.4"],
            31: ["KY.6.SP.3", "KY.6.SP.0.d", "KY.6.SP.5.c"],
            32: ["KY.6.SP.5.b", "KY.6.SP.5.c", "KY.6.SP.5.d", "KY.6.SP.1", "KY.6.SP.4", "KY.6.SP.5.a", "KY.6.SP.5.e"],

            // Unit 9: Putting It All Together (4 weeks)
            33: ["KY.6.G.1", "KY.6.NS.2.a", "KY.6.RP.1"],
            34: ["KY.6.NS.2.b", "KY.6.RP.1", "KY.6.NS.1"],
            35: ["KY.6.RP.1", "KY.6.RP.3.a", "KY.6.RP.3.c"],
            36: ["KY.6.NS.3", "KY.6.RP.2", "KY.6.RP.3.a", "KY.6.RP.3.c"]
        };

        // ensure all standards exist in futureStandardsDict
        for (let week in pacingGuideStandardsDict) {
            for (let standard of pacingGuideStandardsDict[week]) {
                if (!this.state.futureStandardsDict.hasOwnProperty(standard)) {
                    console.error('standard does not exist', standard)
                    return
                }
            }
        }

        // see if all are scheduled
        let scheduled = Object.assign({}, this.state.futureStandardsDict);
        for (let week in pacingGuideStandardsDict) {
            for (let standard of pacingGuideStandardsDict[week]) {
                delete scheduled[standard];
            }
        }
        if (Object.keys(scheduled).length > 0) {
            console.error('standards not scheduled', scheduled)
            return;
        }

        let weeks = {}
        for (let i = 0; i < this.state.totalWeeks; i++) {
            weeks[i] = []
        }

        for (let week in pacingGuideStandardsDict) {
            for (let standard of pacingGuideStandardsDict[week]) {
                weeks[parseInt(week)].push(this.state.futureStandardsDict[standard])
            }
        }

        let futurePacingGuide = {
            standardName: this.state.standardName,
            standardCategory: this.state.standardCategory,
            state: 'SC',
            year: '2023',
            weeks: weeks,
            timeStamp: firebase.firestore.FieldValue.serverTimestamp()
        }

        if (this.state.futurePacingGuide) {
            db.collection(ColType.futurePacingGuides)
                .doc(this.state.futurePacingGuide.id)
                .set(futurePacingGuide, { merge: true })
                .then(() => {
                    //console.log('Future pacing guide updated')
                })
                .catch(error => {
                    //console.error('Error updating future pacing guide', error)
                })
        } else {
            db.collection(ColType.futurePacingGuides)
                .add(futurePacingGuide)
                .then(docRef => {
                    //console.log('Future pacing guide added', docRef.id)
                    futurePacingGuide.id = docRef.id;
                    this.setState({ futurePacingGuide: futurePacingGuide })
                })
                .catch(error => {
                    console.error('Error adding future pacing guide', error)
                })
        }
    }


    copyWeeksToTargetWeek = (weekStart, weekEnd, targetWeekStart) => {
        //console.log('copyWeeksToTargetWeek', weekStart, weekEnd, targetWeekStart)
        const weekDiff = weekEnd - weekStart;
        if (targetWeekStart + weekDiff > 36) {
            //console.log('target week > 36')
            return;
        }
        let pacingGuide = this.state.pacingGuide;
        for (let i = 0; i <= weekDiff; i++) {
            pacingGuide.weeks[targetWeekStart + i] = pacingGuide.weeks[weekStart + i];
        }
        this.setWeeks(pacingGuide.weeks);
    }

    setWeeksToStandards = (standardName, weeksDict) => {
        if (standardName !== this.state.standardName) {
            //console.log('standard name mismatch')
            return;
        }
        let pacingGuide = this.state.pacingGuide;
        Object.keys(weeksDict).map((key) => {
            const weekStandards = weeksDict[key];
            const week = parseInt(key);
            pacingGuide.weeks[week] = [];
            for (let i = 0; i < weekStandards.length; i++) {
                const weekStandard = weekStandards[i];
                if (!this.state.standardsDict.hasOwnProperty(weekStandard)) {
                    //console.log('standard not found', weekStandard, weekStandards)
                    return false
                }
                const standard = this.state.standardsDict[weekStandard];
                pacingGuide.weeks[week].push(standard);
            }
            return false;
        })
        this.setWeeks(pacingGuide.weeks);
    }

    /*shiftWeeksDown = () => {
        let pacingGuide = this.state.pacingGuide;
        let weeks = pacingGuide.weeks;
        const maxWeek = this.state.totalWeeks - 1;

        for (let i = maxWeek; i >= 2; i--) {
            weeks[i] = weeks[i - 1];
        }

        weeks[1] = [];

        //this.setWeeks(weeks);
    }*/
    render() {
        const { match: { url } } = this.props

        return (
            <div>
                <Route path={`${url}/guide/*`}
                    render={props => PacingGuideComponent(props, this.props, this.state)} />
                <Route path={`${url}/lesson-plan/*`}
                    render={props => LessonPlanComponent(props, this.props, this.state)} />
                <Route path={`${url}/weekly-planner/*`}
                    render={props => WeeklyPlannerComponent(props, this.props, this.state)} />
                <Route path={`${url}/games/*`} render={props => GamesComponent(props, this.props, this.state)} />
                {/*<Button style={{
                    position: 'fixed',
                    top: '88px',
                }}
                    onClick={() => {
                        //this.setPacingGuideWithPresetStandards()
                        //this.setFuturePacingGuide()
                        //this.shiftWeeksDown()
                        //this.updatePacingGuideStandards()
                    }}
                >
                    Set pacing guide with preset standards
                </Button>*/}
            </div>
        )
    }
}

export default PacingGuide